import script from "./FranceAuth.vue?vue&type=script&setup=true&lang=ts"
export * from "./FranceAuth.vue?vue&type=script&setup=true&lang=ts"

import "./FranceAuth.vue?vue&type=style&index=0&id=c3ab5252&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3ab5252"]])

export default __exports__